import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import './FAQ.css';
import { Link } from 'react-scroll';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: '¿Cómo funciona el sistema de rastreo de VillaTracking?',
      answer: 'VillaTracking utiliza dispositivos GPS instalados en los vehículos que transmiten datos en tiempo real a nuestros servidores. Estos datos son procesados y presentados en nuestra plataforma web y aplicación móvil, permitiéndote monitorear la ubicación, velocidad, rutas y otros parámetros de tu flota desde cualquier lugar.'
    },
    {
      question: '¿Qué tipo de vehículos pueden ser rastreados?',
      answer: 'Nuestro sistema es compatible con todo tipo de vehículos: automóviles, camionetas, camiones, motocicletas, maquinaria pesada, embarcaciones y más. Los dispositivos GPS se adaptan a las necesidades específicas de cada tipo de vehículo.'
    },
    {
      question: '¿Cuánto tiempo toma la instalación de los dispositivos?',
      answer: 'La instalación típica toma entre 30 y 60 minutos por vehículo, dependiendo del modelo y tipo de instalación requerida. Contamos con un equipo de técnicos certificados que realizan instalaciones profesionales para garantizar el correcto funcionamiento del sistema.'
    },
    {
      question: '¿Necesito conexión a internet para usar VillaTracking?',
      answer: 'Sí, necesitas conexión a internet para acceder a la plataforma web o la aplicación móvil. Sin embargo, los dispositivos GPS siguen recopilando datos incluso en áreas sin cobertura celular, y los transmiten una vez que recuperan la conexión.'
    },
    {
      question: '¿Puedo establecer alertas personalizadas?',
      answer: 'Absolutamente. VillaTracking permite configurar múltiples tipos de alertas: exceso de velocidad, entrada/salida de geocercas, paradas prolongadas, uso fuera de horario, botón de pánico, desconexión de batería y muchas más. Estas alertas pueden ser recibidas por email, SMS o notificaciones push.'
    },
    {
      question: '¿Qué sucede si un vehículo entra en un área sin cobertura celular?',
      answer: 'Cuando un vehículo está en un área sin cobertura, el dispositivo GPS continúa registrando datos localmente. Una vez que el vehículo regresa a un área con cobertura, el dispositivo transmite automáticamente todos los datos almacenados, asegurando que no haya pérdida de información.'
    },
    {
      question: '¿Ofrecen soporte técnico?',
      answer: 'Sí, ofrecemos soporte técnico completo. Dependiendo del plan elegido, puede incluir soporte por email, chat, teléfono o incluso soporte 24/7 para nuestros clientes empresariales. Nuestro equipo está altamente capacitado para resolver cualquier incidencia rápidamente.'
    },
    {
      question: '¿Puedo cambiar de plan o cancelar el servicio?',
      answer: 'Sí, puedes cambiar de plan en cualquier momento según las necesidades de tu negocio. Nuestros servicios no requieren contratos a largo plazo, por lo que puedes cancelar cuando lo desees. Solo requerimos un aviso previo de 30 días para procesamiento administrativo.'
    }
  ];

  return (
    <section id="faq" className="section">
      <div className="container">
        <h2 className="section-title">Preguntas Frecuentes</h2>
        <p className="section-subtitle">
          Encuentra respuestas a las preguntas más comunes sobre nuestro sistema de rastreo vehicular.
        </p>

        <div className="faq-container">
          {faqs.map((faq, index) => (
            <div
              className={`faq-item ${activeIndex === index ? 'active' : ''}`}
              key={index}
            >
              <div
                className="faq-question"
                onClick={() => toggleAccordion(index)}
              >
                <h3>{faq.question}</h3>
                {activeIndex === index ? (
                  <ChevronUp size={20} />
                ) : (
                  <ChevronDown size={20} />
                )}
              </div>
              <div className={`faq-answer ${activeIndex === index ? 'active' : ''}`}>
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="faq-cta">
          <p>¿No encuentras la respuesta que buscas?</p>
          <Link
            to="contact"
            spy={true}
            smooth={true}
            offset={-80}
            duration={500}
            className="btn btn-primary"
          >
            Contáctanos
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FAQ;